export const appsUserInfoGetClickThroughTrackingConfig = "/apps/user_info/get_click_through_tracking_config";
